import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react-use-analytics-api/react-use-analytics-api/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { SvgIcon } from '../gatsby-theme-docz/tools/SvgIcon';
import githubSvg from '../__docz__/images/github.svg';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "️-deprecated"
    }}>{`⛔️ DEPRECATED`}</h1>
    <div style={{
      display: 'flex',
      alignItems: 'baseline'
    }}>
  <div>
    <h1>React Use Analytics API</h1>
  </div>
  <div>
    <a href="https://github.com/justinmahar/react-use-analytics-api" target="_blank" rel="noopener noreferrer">
      <SvgIcon src={githubSvg} size={28} style={{
            margin: '0 0 0 20px'
          }} mdxType="SvgIcon" />
    </a>
  </div>
    </div>
    <h2 {...{
      "id": "️-deprecation-notice-google-analytics-4-is-replacing-universal-analytics-making-this-library-obsolete-after-july-1-2023-all-standard-universal-analytics-properties-will-stop-processing-new-hits-read-more-here"
    }}>{`⛔️ DEPRECATION NOTICE: Google Analytics 4 is replacing Universal Analytics, making this library obsolete. After July 1, 2023 all standard Universal Analytics properties will stop processing new hits. `}<a parentName="h2" {...{
        "href": "https://support.google.com/analytics/answer/10759417?utm_campaign=2022-q4-gbl-all-gafree&utm_source=google-growth&utm_medium=email&utm_content=ga-sunset-msa-reminder-read"
      }}>{`Read more here`}</a>{`.`}</h2>
    <p><strong parentName="p">{`React hook for loading the `}<a parentName="strong" {...{
          "href": "https://ga-dev-tools.appspot.com/embed-api/"
        }}>{`Google Analytics Embed API`}</a>{`.`}</strong></p>
    <p>{`👁️ `}<strong parentName="p"><a parentName="strong" {...{
          "href": "/react-use-analytics-api/useDataChart#example"
        }}>{`Full Example`}</a></strong></p>
    <p><em parentName="p">{`For components, check out: `}<a parentName="em" {...{
          "href": "https://justinmahar.github.io/react-analytics-charts/"
        }}>{`React Analytics Charts`}</a></em></p>
    <h2 {...{
      "id": "overview"
    }}>{`Overview`}</h2>
    <p>{`The `}<a parentName="p" {...{
        "href": "/react-use-analytics-api/useAnalyticsApi"
      }}><inlineCode parentName="a">{`useAnalyticsApi`}</inlineCode></a>{` hook can be used to load and ready the `}<a parentName="p" {...{
        "href": "https://ga-dev-tools.appspot.com/embed-api/"
      }}>{`Google Analytics Embed API`}</a>{` in React.`}</p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`What is the Google Analytics Embed API?`}</strong>{` It is a JavaScript library that allows you to easily create and embed Google Analytics charts on a third-party website in a matter of minutes.`}</p>
    </blockquote>
    <p>{`This library also provides helper hooks for the API's `}<a parentName="p" {...{
        "href": "https://developers.google.com/analytics/devguides/reporting/embed/v1/component-reference"
      }}>{`built-in components`}</a>{`:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-use-analytics-api/useAuthorize"
        }}>{`useAuthorize`}</a>{` - `}<a parentName="li" {...{
          "href": "https://developers.google.com/analytics/devguides/reporting/embed/v1/component-reference#auth"
        }}>{`Authorize`}</a>{` the user`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-use-analytics-api/useViewSelector"
        }}>{`useViewSelector`}</a>{` - Render an Analytics `}<a parentName="li" {...{
          "href": "https://developers.google.com/analytics/devguides/reporting/embed/v1/component-reference#viewselector"
        }}>{`ViewSelector`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-use-analytics-api/useDataChart"
        }}>{`useDataChart`}</a>{` - Render a `}<a parentName="li" {...{
          "href": "https://developers.google.com/analytics/devguides/reporting/embed/v1/component-reference#datachart"
        }}>{`DataChart`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-use-analytics-api/useData"
        }}>{`useData`}</a>{` - Query `}<a parentName="li" {...{
          "href": "https://developers.google.com/analytics/devguides/reporting/embed/v1/component-reference#data"
        }}>{`data`}</a>{` from the Google Analytics Core Reporting API and get back the results`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-use-analytics-api/useSignOut"
        }}>{`useSignOut`}</a>{` - `}<a parentName="li" {...{
          "href": "https://developers.google.com/analytics/devguides/reporting/embed/v1/component-reference#auth"
        }}>{`Sign the user out`}</a></li>
    </ul>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Looking for components?`}</strong>{` A full React component library that wraps these hooks is now available! Check out `}<a parentName="p" {...{
          "href": "https://justinmahar.github.io/react-analytics-charts/"
        }}>{`React Analytics Charts`}</a>{`.`}</p>
    </blockquote>
    <h3 {...{
      "id": "features-include"
    }}>{`Features include:`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`🚀 Easily load the Google Analytics Embed API`}</strong>
        <ul parentName="li">
          <li parentName="ul">{`Loading and readying the API is handled for you so you can just focus on the good stuff, like embedding charts.`}</li>
        </ul>
      </li>
      <li parentName="ul"><strong parentName="li">{`📈 Drop in charts quickly and easily`}</strong>
        <ul parentName="li">
          <li parentName="ul">{`Embed Google Analytics charts on your site in minutes.`}</li>
        </ul>
      </li>
      <li parentName="ul"><strong parentName="li">{`💁 From auth to charts, it's handled for you`}</strong>
        <ul parentName="li">
          <li parentName="ul">{`Side-effects are handled for common API operations. Need to handle the auth flow, render a view selector, or render charts? Got ya covered!`}</li>
        </ul>
      </li>
      <li parentName="ul"><strong parentName="li">{`🧼 Minimized `}<inlineCode parentName="strong">{`window`}</inlineCode>{` dependence`}</strong>
        <ul parentName="li">
          <li parentName="ul">{`Google loads the API to `}<inlineCode parentName="li">{`window`}</inlineCode>{`, but this hook pulls the API into a singleton to limit `}<inlineCode parentName="li">{`window`}</inlineCode>{` dependence.`}</li>
        </ul>
      </li>
      <li parentName="ul"><strong parentName="li">{`🤝 Hooks stay synchronized`}</strong>
        <ul parentName="li">
          <li parentName="ul">{`When calling the API hook in multiple places, changes to readiness and auth will propate to all hooks, keeping them in sync.`}</li>
        </ul>
      </li>
      <li parentName="ul"><strong parentName="li">{`✨ Full examples and rich documentation`}</strong>
        <ul parentName="li">
          <li parentName="ul">{`Develop easier with plenty of examples, starting points, and rich docs.`}</li>
        </ul>
      </li>
      <li parentName="ul"><strong parentName="li">{`And more!`}</strong></li>
    </ul>
    <h2 {...{
      "id": "installation"
    }}>{`Installation`}</h2>
    <pre><code parentName="pre" {...{}}>{`npm i react-use-analytics-api
`}</code></pre>
    <h2 {...{
      "id": "quick-start"
    }}>{`Quick Start`}</h2>
    <p>{`To load the Google Analytics Embed API, use the `}<a parentName="p" {...{
        "href": "/react-use-analytics-api/useAnalyticsApi"
      }}><inlineCode parentName="a">{`useAnalyticsApi`}</inlineCode></a>{` hook:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { useAnalyticsApi } from 'react-use-analytics-api';
`}</code></pre>
    <p>{`Then in your function component:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const { ready, gapi, authorized, error } = useAnalyticsApi();
`}</code></pre>
    <p>{`When `}<inlineCode parentName="p">{`ready`}</inlineCode>{` is `}<inlineCode parentName="p">{`true`}</inlineCode>{`, the `}<inlineCode parentName="p">{`gapi`}</inlineCode>{` object will be set to the loaded and ready-to-use `}<a parentName="p" {...{
        "href": "/react-use-analytics-api/useAnalyticsApi"
      }}>{`Google Analytics Embed API`}</a>{`. The `}<inlineCode parentName="p">{`gapi`}</inlineCode>{` object will be `}<inlineCode parentName="p">{`undefined`}</inlineCode>{` until it is ready to use.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`authorized`}</inlineCode>{` property will be `}<inlineCode parentName="p">{`true`}</inlineCode>{` when the user is authorized, `}<inlineCode parentName="p">{`false`}</inlineCode>{` otherwise.`}</p>
    <p>{`From here, you can `}<a parentName="p" {...{
        "href": "/react-use-analytics-api/useAuthorize"
      }}>{`authorize the user`}</a>{`, `}<a parentName="p" {...{
        "href": "/react-use-analytics-api/useViewSelector"
      }}>{`render a view selector`}</a>{`, and `}<a parentName="p" {...{
        "href": "/react-use-analytics-api/useDataChart"
      }}>{`render charts`}</a>{`... or do `}<a parentName="p" {...{
        "href": "/react-use-analytics-api/useAnalyticsApi#using-the-api-itself"
      }}>{`anything else you want`}</a>{` with the API!`}</p>
    <blockquote>
      <p parentName="blockquote">{`🏁 For a full example demonstrating all features of this library including full auth flow, see the `}<a parentName="p" {...{
          "href": "/react-use-analytics-api/useDataChart#example"
        }}>{`useDataChart example`}</a>{`. This is a great starting point for building your own charts dashboard.`}</p>
    </blockquote>
    <h2 {...{
      "id": "typescript"
    }}>{`TypeScript`}</h2>
    <p>{`Type definitions have been included for `}<a parentName="p" {...{
        "href": "https://www.typescriptlang.org/"
      }}>{`TypeScript`}</a>{` support.`}</p>
    <h2 {...{
      "id": "contributing"
    }}>{`Contributing`}</h2>
    <p>{`Open source software is awesome and so are you. 😎`}</p>
    <p>{`Feel free to submit a pull request for bugs or additions, and make sure to update tests as appropriate. If you find a mistake in the docs, send a PR! Even the smallest changes help.`}</p>
    <p>{`For major changes, open an issue first to discuss what you'd like to change.`}</p>
    <p>{`See `}<a parentName="p" {...{
        "href": "https://tinyurl.com/kindlingscripts"
      }}>{`Kindling`}</a>{` for npm script documentation.`}</p>
    <h2 {...{
      "id": "-found-it-helpful-star-it"
    }}>{`⭐ Found It Helpful? `}<a parentName="h2" {...{
        "href": "https://github.com/justinmahar/react-use-analytics-api/stargazers"
      }}>{`Star It!`}</a></h2>
    <p>{`If you found this project helpful, let the community know by giving it a `}<a parentName="p" {...{
        "href": "https://github.com/justinmahar/react-use-analytics-api/stargazers"
      }}>{`star`}</a>{`: `}<a parentName="p" {...{
        "href": "https://github.com/justinmahar/react-use-analytics-api/stargazers"
      }}>{`👉⭐`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      